import GoogleAnalytics from 'react-ga';
import { queueESEvents, ESEventTypes } from '../businessLogic/logEventToElasticSearch';

export const DISPLAY_GLOBAL_MESSAGE = 'DISPLAY_GLOBAL_MESSAGE';
export const HIDE_GLOBAL_MESSAGE = 'HIDE_GLOBAL_MESSAGE';

export function displayGlobalMessage(messageData) {
  if (
    messageData.messageType === APP.LANGUAGE.GlobalMessageTypes.Bad &&
    window.APP.CONFIGURATION.GOOGLE_ANALYTICS_PROPERTY_ID
  ) {
    // TODO - Log this into New Relic instead (after 3.9.1 is out)
    GoogleAnalytics.event({
      category: 'VCM',
      action: `Red Error message Shown`,
    });
    // for some kind of red message, we don't want it to explode the log
    let messageString = messageData.text.toString();
    if (
      messageString.indexOf('Cannot connect to') > -1 ||
      messageString.indexOf('Your computer seems to be offline.') > -1
    ) {
      queueESEvents(ESEventTypes.RedMessageShown, messageString, 'eventName');
    } else {
      let additionalValue = null;
      if (!!messageData.apiURL && !!messageData.browserURL) {
        additionalValue = { apiURL: messageData.apiURL, browserURL: messageData.browserURL };
      } else if (!!messageData.apiURL) {
        additionalValue = { apiURL: messageData.apiURL };
      } else if (!!messageData.browserURL) {
        additionalValue = { browserURL: messageData.browserURL };
      }
      queueESEvents(ESEventTypes.RedMessageShown, messageString, 'eventName&apiURL', additionalValue);
    }
  }

  return (dispatch) => {
    dispatch({ type: HIDE_GLOBAL_MESSAGE });
    dispatch({ type: DISPLAY_GLOBAL_MESSAGE, data: messageData });
  };
}
export function hideGlobalMessage() {
  return (dispatch) => {
    dispatch({ type: HIDE_GLOBAL_MESSAGE });
  };
}
